import { motion } from 'motion/react';
import { forwardRef } from 'react';

type Props = {
  className?: string;
};

const EPiece = forwardRef<HTMLDivElement, Props>(({ className }, ref) => {
  return (
    <div ref={ref} className={className}>
      <svg
        width='130'
        height='29'
        viewBox='0 0 130 29'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path d='M8.45019 28.2334C4.03191 28.2334 0.450195 24.6517 0.450195 20.2334L0.450194 8.09131C0.450194 3.67303 4.03192 0.0913084 8.45019 0.0913082L121.631 0.0913033C126.049 0.0913031 129.631 3.67303 129.631 8.0913L129.631 20.2334C129.631 24.6517 126.049 28.2334 121.631 28.2334L8.45019 28.2334Z' />
      </svg>
    </div>
  );
});

EPiece.displayName = 'EPiece';

export default motion.create(EPiece);
